import { render, staticRenderFns } from "./ReportExtendedLoanTerm.vue?vue&type=template&id=f6f8cc9a"
import script from "./ReportExtendedLoanTerm.vue?vue&type=script&lang=js"
export * from "./ReportExtendedLoanTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports